import { React, useState, useEffect } from "react";
import classes from './Results.module.scss'
import Chart from "./Chart";
import Table from "./Table";

// MUI Imports
import Box from '@mui/material/Box';

function Results({project, schema , csvDownloadUrl}) {

    const [results, setResults] = useState([])
    const [tableData , setTableData] = useState(null)

    const [totalPriorityQuestionCount, setTotalPriorityQuestionCount] = useState(0);


    function getChartChoiceLabels(){

        let labels = []
        schema.entryOptions.screen.screening.fields.forEach((element) => {

            if(project.entries.screeningLayerOptions[element.key] === true){
              let label = schema.screenContent.results.layerAxies[element.key].layerTitle
              labels.push(label)
            }


        })

        return labels

    }

    function getChartChoices(){

        let labels = []

        schema.entryOptions.screen.screening.fields.forEach((element) => {
            if(project.entries.screeningLayerOptions[element.key] === true){
                labels.push(element)
        }

      })

      return labels

    }

    function getPhaseDetails(phase, phaseMeta){

        let layerChoices = getChartChoices()

        let phaseAnswerLayerCounts = {}
   
        let defaultTableCounts = {

        }

        Object.keys(schema.entryOptions.screen.assessment.riskOptions.options).forEach((key => {

            let riskElement = schema.entryOptions.screen.assessment.riskOptions.options[key]
            
            defaultTableCounts[riskElement.value] = {
                count:0,
                label:riskElement.label,
                riskKey:key
            }
            

        }))

        defaultTableCounts = JSON.stringify(defaultTableCounts)

        let hasPhaseBeenAnswered = false;

        layerChoices.forEach((element, labelIndex) => {

            let layer = phase[element.key];
            
            if(layer !== undefined){

                layer.choiceCounts = JSON.parse(defaultTableCounts);
                layer.choiceWeightCounts = JSON.parse(defaultTableCounts);
                layer.label = schema.screenContent.results.layerAxies[element.key].layerTitle
                layer.questions.forEach((answer) => {

                    if(answer){
                        if(answer.danger !== undefined){
                            let choiceWeight = Object.entries(schema.entryOptions.screen.assessment.riskOptions.options).filter(item => item[1].value === answer.danger)[0][1].weight
                            let tableItemKey = Object.entries(schema.entryOptions.screen.assessment.riskOptions.options).filter(item => item[1].value === answer.danger)[0][1].value
                            layer.choiceCounts[tableItemKey].count = layer.choiceCounts[tableItemKey].count + 1
                            layer.choiceWeightCounts[tableItemKey].count = layer.choiceWeightCounts[tableItemKey].count + choiceWeight
            
                            phaseAnswerLayerCounts[element.key] = layer
                            hasPhaseBeenAnswered = true
                        }
                    }

                })
            } 

        })

        let barChartData = []

        if(hasPhaseBeenAnswered){

            let choiceCounts = Object.entries(phaseAnswerLayerCounts)[0][1].choiceCounts
            let order = 0;
            for (const [key, answerLayerCount] of Object.entries(choiceCounts)) {
                let shouldAddToChart = false
                let chartData = {
                    label: answerLayerCount.label,
                    data: Object.entries(phaseAnswerLayerCounts).map((item, index) => {
                        if(item[1].choiceWeightCounts[key].count !== 0){
                            shouldAddToChart = true
                        }
                        return item[1].choiceWeightCounts[key].count
                    }),
                    order:(answerLayerCount.label === "Watch out" ? -1 : order),
                    borderColor:  schema.entryOptions.screen.assessment.riskOptions.options[answerLayerCount.riskKey].chartColour,
                    backgroundColor:  schema.entryOptions.screen.assessment.riskOptions.options[answerLayerCount.riskKey].chartColour,
                    borderWidth: 1
                }
                if(shouldAddToChart){
                    barChartData.push(chartData)
                    order++
                }

            }
        }

        const dataSet = (
            hasPhaseBeenAnswered ? {
                chartData:barChartData,
                tableData:phaseAnswerLayerCounts
            } 
            : 
            null
        );

        return dataSet
    }

    useEffect(() => {
        if(project){

            let barChartPhaseData = []
            let tableData = []
            let priorityQuestions = [];

           

            if(project.entries.assessment.priorityQuestions === null || project.entries.assessment.priorityQuestions === undefined ){
                
            }
            else{
                
                priorityQuestions = Object.entries(project.entries.assessment.priorityQuestions);
                setTotalPriorityQuestionCount(priorityQuestions.reduce((total, currentValue) => total = total + currentValue[1].length,0))
            }

            schema.screenContent.assessment.phases.forEach((element, index) => {
                if(project.entries.assessment.phases !== undefined){
                    if(project.entries.assessment.phases[element.key] !== undefined){

                        let phaseDataset = getPhaseDetails(
                            project.entries.assessment.phases[element.key], 
                            schema.screenContent.assessment.phases[index]);

                        if(phaseDataset){
                            barChartPhaseData.push(
                                {
                                    labels: getChartChoiceLabels(),
                                    datasets: phaseDataset.chartData,
                                    phaseName:element.name,
                                    helperText:element.body
                                }
                            )
                            tableData.push(phaseDataset.tableData)
                        }

                    }
                }
            })
            
            setResults(barChartPhaseData)
            setTableData(tableData)
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[project])

  return (
    <div>
      {(
        results.length > 0
            ?
            
            <Box className={`content_wrapper__inner`}>
                {results.map((resultsForPhase, index) => {
                    return(
                        <Box className={`${classes.Results__content_container} gain_content_container`} key={index}>
                            <section className={`gain_content_container__form_container`}>
                                <h2 className={`${classes.Results__content_container__phase_title}`}>{resultsForPhase.phaseName} phase</h2>
                                <div style={{width:"100%", margin:"0 auto", display:"block"}}>
                                    <div className={`${classes.Results__table}`}>
                                        <Table
                                            tableData={tableData[index]} 
                                            schema={schema}
                                        />
                                    </div>

                                    <Chart
                                        resultsForPhase={resultsForPhase}
                                    />
   
                                </div>
                            </section>
                            <section className={`gain_content_container__guidance`}>
                                <p className={"small_copy"}>You can export the answers as a <a target={'_blank'} rel="noreferrer" href={`${csvDownloadUrl}`}>csv file</a></p>
                                <p className={`subtitle_copy`}>{resultsForPhase.helperText.subtitle}</p>
                                <p className={`small_copy`}>{resultsForPhase.helperText.copy}</p>
                                {(
                                    totalPriorityQuestionCount > 0 ?
                                    <div className={`${classes.Results__priority_questions_container}`}>
                                        <p className={`subtitle_copy`}>Priority Questions</p>
                                        {Object.entries(project.entries.assessment.priorityQuestions).map((layer, index) => {
                                            return(
                                                <>
                                                {(
                                                    layer[1].length > 0 ? 
                                                        <div key={index} className={`${classes.Results__priority_questions}`}>
                                                            <p className={`${classes.Results__priority_questions__layer_title} subtitle_copy`} dangerouslySetInnerHTML={{__html:schema.screenContent.results.layerAxies[layer[0]].layerTitle}}></p>
                                                            <br/>
                                                            {layer[1].map((questionIndex, index) => {     
                                                                return <li key={index} className={`${classes.Results__priority_questions__layer_copy} small_copy`} dangerouslySetInnerHTML={{__html:schema.screenContent.assessment.impactLayers[layer[0]].questions[questionIndex].copy}}></li>
                                                            })}
                                                        </div>
                                                    :
                                                    ""
                                                )}
                                                </>
                                            )
                                        })}
                                    </div>
                                    :
                                    ""
                                )}
                            </section>
                        </Box>
                    )
                })}
                
                
            </Box>
            :
            <h2 className={`holder_text content_wrapper__inner ${classes.Results__holder_text}`}>Please fill in the Assessment mitigations survey</h2>
        )}

    </div>
  );
}
export default Results